import type {
  SubscriptionApi,
  SubscriptionApiQuery,
  SubscribeApiQuery,
  CancelSubscriptionApiQuery,
  UpdateSubscriptionStatusApiQuery,
} from "@/Modules/Models/Api/Subscription";

import { SubscriptionApiStatus } from "@/Modules/Models/Api/Subscription";

import TherapySideApiService from "./utils/TherapyApi";
class SubscriptionApiConnector {
  constructor(private readonly ApiService: TherapySideApiService = new TherapySideApiService()) {}

  getSubscription(customerUuid: string): Promise<SubscriptionApi> {
    return this.ApiService.get<SubscriptionApiQuery, SubscriptionApi>({
      endpoint: "/v1.0/subscriptions",
      params: {
        customer_uuid: customerUuid,
      },
    });
  }

  subscribeToPlan(subscribeApiQuery: SubscribeApiQuery): Promise<SubscriptionApi> {
    return this.ApiService.post<SubscribeApiQuery, SubscriptionApi>({
      endpoint: "/v1.0/subscriptions",
      body: subscribeApiQuery,
    });
  }

  cancelSubscription(cancelSubscriptionApiQuery: CancelSubscriptionApiQuery): Promise<void> {
    return this.ApiService.delete<CancelSubscriptionApiQuery, void>({
      endpoint: "/v2.0/subscriptions",
      data: cancelSubscriptionApiQuery,
    });
  }

  updateSubscriptionStatus(subscriptionUuid: string): Promise<SubscriptionApi> {
    return this.ApiService.patch<UpdateSubscriptionStatusApiQuery, SubscriptionApi>({
      endpoint: `/v1.0/subscriptions/${subscriptionUuid}`,
      body: {
        status: SubscriptionApiStatus.ACTIVE,
      },
    });
  }
}

export default SubscriptionApiConnector;
